export function median(values: number[]): number | null {
	if (values.length === 0) return null;
	const sorted = [...values].sort((a, b) => a - b);
	const mid = Math.floor(sorted.length / 2);
	return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];
}

// Bathroom scales here read to 1/20 kg (0.05 kg) increments.
export function formatWeight(weight: number): string {
	return weight.toFixed(2);
}

// Split for display so the whole kilos can be styled larger/darker than the
// fractional part, which matters far less at a glance.
export function weightWhole(weight: number): string {
	return formatWeight(weight).split(".")[0];
}

export function weightFrac(weight: number): string {
	return formatWeight(weight).split(".")[1];
}
